<template>
  <div class="footer">
    <div class="copyright">
      Copyright
      <CopyrightOutlined/> 2021 <span>{{ title }}</span>
    </div>
  </div>
</template>

<script>
import config from '@/config';
import { defineComponent, ref, onMounted } from 'vue';
import { CopyrightOutlined } from '@ant-design/icons-vue';
export default defineComponent({
  components: {
    CopyrightOutlined,
  },
  name: 'GlobalFooter',

  setup() {
    const configInit = ref(config);
    const title = ref('');
    onMounted(() => {
      title.value = configInit.value.logoTitle; 
    });
    return {
      title,
      config: configInit,
    };
  },
  mounted() {
   
  }
});
</script>

<style lang="less" scoped>
.footer {
  padding: 0 16px;
  margin: 48px 0 24px;
  text-align: center;

  .links {
    margin-bottom: 8px;

    a {
      color: rgba(0, 0, 0, 0.45);

      &:hover {
        color: rgba(0, 0, 0, 0.65);
      }

      &:not(:last-child) {
        margin-right: 40px;
      }
    }
  }
  .copyright {
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
  }
}
</style>
